export default __webpack_public_path__ + "static/media/momosan.91c4e570.jpeg";